import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

export interface IWarningProps extends IIconProps {
  width?: number;
  height?: number;
}

const Warning: React.FC<IWarningProps> = ({
  width,
  height,
  size = IconSizes.lg,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={width || IconWidth[size]}
      height={height || IconHeight[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M14.4197 4.00772C15.1875 2.66409 17.1249 2.66409 17.8927 4.00772L30.4463 25.9766C31.2082 27.3099 30.2455 28.9689 28.7099 28.9689H3.60257C2.06692 28.9689 1.10418 27.3099 1.86608 25.9766L14.4197 4.00772Z"
        fill="#FF573E"
      />
      <path
        d="M18.7271 23.2834C18.7271 24.656 17.6143 25.7687 16.2417 25.7687C14.8691 25.7687 13.7563 24.656 13.7563 23.2834C13.7563 21.9108 14.8691 20.798 16.2417 20.798C17.6143 20.798 18.7271 21.9108 18.7271 23.2834Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2417 24.3485C16.83 24.3485 17.3069 23.8717 17.3069 23.2834C17.3069 22.6951 16.83 22.2182 16.2417 22.2182C15.6534 22.2182 15.1766 22.6951 15.1766 23.2834C15.1766 23.8717 15.6534 24.3485 16.2417 24.3485ZM16.2417 25.7687C17.6143 25.7687 18.7271 24.656 18.7271 23.2834C18.7271 21.9108 17.6143 20.798 16.2417 20.798C14.8691 20.798 13.7563 21.9108 13.7563 23.2834C13.7563 24.656 14.8691 25.7687 16.2417 25.7687Z"
        fill="black"
      />
      <path
        d="M13.7563 12.4541C13.7563 11.0815 14.8691 9.96875 16.2417 9.96875C17.6143 9.96875 18.7271 11.0815 18.7271 12.4541V17.4248C18.7271 18.7975 17.6143 19.9102 16.2417 19.9102C14.8691 19.9102 13.7563 18.7975 13.7563 17.4248V12.4541Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3069 17.4248V12.4541C17.3069 11.8658 16.83 11.389 16.2417 11.389C15.6534 11.389 15.1766 11.8658 15.1766 12.4541V17.4248C15.1766 18.0131 15.6534 18.49 16.2417 18.49C16.83 18.49 17.3069 18.0131 17.3069 17.4248ZM16.2417 9.96875C14.8691 9.96875 13.7563 11.0815 13.7563 12.4541V17.4248C13.7563 18.7975 14.8691 19.9102 16.2417 19.9102C17.6143 19.9102 18.7271 18.7975 18.7271 17.4248V12.4541C18.7271 11.0815 17.6143 9.96875 16.2417 9.96875Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.0571 26.7704L16.5035 4.80154C16.3499 4.53282 15.9625 4.53282 15.8089 4.80154L3.25527 26.7704C3.10289 27.0371 3.29544 27.3689 3.60257 27.3689H28.7099C29.017 27.3689 29.2095 27.0371 29.0571 26.7704ZM17.8927 4.00772C17.1249 2.66409 15.1875 2.66409 14.4197 4.00772L1.86608 25.9766C1.10418 27.3099 2.06692 28.9689 3.60257 28.9689H28.7099C30.2455 28.9689 31.2082 27.3099 30.4463 25.9766L17.8927 4.00772Z"
        fill="black"
      />
    </svg>
  );
};

export default Warning;
